module.exports = __webpack_public_path__ + "static/BrandonGrotesque-LightItalic-3913e72b36aedbec8dcae347c9c9c593.ttf";